import React from 'react'
import styled from 'styled-components'
import { Web3Button, Web3Modal } from '@web3modal/react'
import { useNetwork } from 'wagmi'
import { ethereumClient } from '../../hooks/useWallet'
import { Step } from './components/Step'
import { PanelWrapper } from './components/ConnectWallet'
import { Create } from './Create'
import { Bridge } from '../bridge/Bridge'

export const Connect = () => {
  const { chain } = useNetwork()
  return (
    <AppContainer>
      {!chain && (
        <Step title="Step 1 of 2: Connect your wallet">
          <>
            <PanelWrapper>
              <Web3Button />
            </PanelWrapper>
            <Web3Modal
              projectId="9a2846ab319d3e074b744395e11c7fae"
              ethereumClient={ethereumClient}
            />
          </>
        </Step>
      )}
      {chain && chain.id !== 5 && <Create />}
      {chain && chain.id === 5 && <Bridge />}
    </AppContainer>
  )
}

export const AppContainer = styled.div`
  height: calc(100vh - 134px);
  display: flex;
  align-items: center;
  justify-content: center;
`
